// AUTO-GENERATED by scripts/gen-og-manifest.js — do not edit by hand.
// Slugs that have a dedicated public/og/<slug>.png. Regenerate with
// `npm run og:manifest` whenever you add or remove an OG image.
export const OG_AVAILABLE: string[] = [];
